export const checkForHTTP = (_http) => {
  if (!_http) {
    throw new Error('gold-vehicle-api is not initalized. See docs for gold-vehilce-api on how to initialize.');
  }
  return _http;
};

export const readableToStringProto = (field) => ({
  toString() {
    return this[field];
  },
});

export const displayNameToStringProto = readableToStringProto('displayName');



// WEBPACK FOOTER //
// ./src/api-purecars/utils.js